<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <h3 class="h4">{{ comments.total }} Enrollee Feedback</h3>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="container">
          <div class="col-md-12 card">
            <div class="card-header"></div>

            <div class="card-body row">
              <div
                class="form-group col-md-4"
                v-if="user.type == 'shis' || user.type == 'employee'"
              >
                <label> Select Facility </label>

                <v-select
                  v-model="form.provider_id"
                  :reduce="agency_name => agency_name.id"

                  label="agency_name"
                  :options="providers"
                />
              </div>

              <div class="form-group col-md-4">
                <label for="inputCity"
                  ><i class="fe fe-calendar"></i> Start Date
                </label>
                <input type="date" class="form-control" v-model="form.from" />
              </div>

              <div class="form-group col-md-4">
                <label for="inputCity"
                  ><i class="fe fe-calendar"></i> End Date
                </label>
                <input type="date" class="form-control" v-model="form.to" />
              </div>

              <div class="col-md-12">
                <button
                  class="btn btn-outline-info btn-block"
                  @click="getComments"
                >
                  Filter
                </button>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-md-12">
              <div class="card">
                <div class="card card-header">
                  <p class="h4">
                    <!-- Request(s) -->
                    <i class="mdi mdi-message"></i>
                  </p>
                </div>
                <div class="card card-body">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>Enrollee</th>
                          <th>Facility</th>
                          <th>Rating</th>
                          <th>Comment</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="trf in comments.data" v-bind:key="trf.id">
                          <td>
                            <span v-if="trf.user != null">
                              {{ trf.user.full_name }}
                            </span>
                          </td>
                          <td>{{ trf.provider.agency_name }}</td>
                          <td>
                            <span v-if="trf.health_record != null">
                              <star-rating
                                star-size="15"
                                :rating="trf.health_record.rating.score"
                                :show-rating="false"
                                read-only="true"
                                active-color="#198754"
                              ></star-rating>
                            </span>
                          </td>

                          <td>
                            {{ trf.body }}

                            <span class="text-muted small ml-2">
                              {{ trf.created_at | moment("from", "now") }}
                            </span>
                          </td>
                          <td>
                            <div class="btn-group CTAs">
                              <button
                                class="btn btn-outline-dark m-1"
                                data-toggle="modal"
                                data-target="#slideRightModalAll"
                                @click="getRequest(trf)"
                              >
                                <i class="fe fe-eye"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="col-md-12">
                    <span class="pagination__CTAs">
                      <button
                        class="btn btn-primary next__page"
                        @click="DecreamentPage"
                      >
                        Previous page
                      </button>
                      <p class="currentPage">{{ pageNum }}</p>
                      <button
                        class="btn btn-primary previous__page"
                        @click="IncreamentPage"
                      >
                        Next page
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal -->
            <div
              class="modal fade modal-slide-right"
              id="slideRightModalAll"
              tabindex="-1"
              role="dialog"
              aria-labelledby="slideRightModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content" id="printDiv" ref="printNow">
                  <div class="modal-header" v-if="single_request">
                    <p class="modal-title" id="slideRightModalLabel">
                      <span class="h5">Feedback </span>

                      <a
                        class="btn m-b-15 badge badge-soft-dark btn-sm mx-1 mt-2"
                        role="button"
                        target="_blank"
                        :href="`/encounter/${single_request.health_record.id}`"
                      >
                        Encounter <i class="mdi mdi-medical-bag"></i>
                      </a>
                    </p>

                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body" v-if="single_request">
                    <div class="">
                      <p class="my-3">
                        <b>Enrollee Name</b>
                        {{ single_request.user.full_name }}
                      </p>

                      <p class="my-3">
                        <b>Enrollee ID</b>
                        {{ single_request.user.id_card_number }}
                      </p>

                      <p class="my-3">
                        <b>Enrollee Phone Number</b>
                        {{ single_request.user.phone_number }}
                      </p>

                      <p class="my-3">
                        <b>Enrollee Programme</b>
                        {{ single_request.user.sector }}
                      </p>

                      <p class="my-3">
                        <b> Health Facility </b>

                        <a
                          class="btn m-b-15 badge badge-soft-dark btn-sm mx-1 mt-2"
                          role="button"
                          target="_blank"
                          :href="`/provider-${single_request.provider_id}`"
                        >
                          {{ single_request.provider.agency_name }}
                        </a>
                      </p>

                      <p class="my-3">
                        <b> Comment</b>
                        {{ single_request.body }}
                      </p>

                      <p class="my-2">
                        <b> Date</b>
                        {{
                          single_request.created_at
                            | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                        }}
                      </p>
                    </div>

                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 m-b-30">
                          <div class="card">
                            <div class="card-header border-bottom"></div>

                            <div class="card-footer row"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <div class="row col-md-12" v-if="single_request">
                      <div class="col-md-6">
                        <a
                          :href="`/encounter/${single_request.health_record.id}`"
                          class="btn btn-success btn-block"
                        >
                          View Encounter <i class="mdi mdi-medical-bag"></i>
                        </a>
                      </div>

                      <div class="col-md-6">
                        <a
                          :href="`/provider-${single_request.provider_id}`"
                          class="btn btn-info btn-block"
                        >
                          View Provider
                          <i class="fe fe-activity"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--End of Modal -->
          </div>
        </div>
      </section>
    </main>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </section>
</template>
  
  <script>
import Navbar from "@/views/Navbar.vue";
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import StarRating from "vue-star-rating";

export default {
  components: {
    Navbar,
    Loading,
    StarRating,
  },
  data() {
    return {
      // editor: ClassicEditor,
      user: null,
      search_result: "",
      enrollee_details: "",
      searchkey: "",
      comments: "",
      transfers: "",
      providers: "",
      history: "",
      single_request: null,
      pageNum: 1,
      edit: false,
      isLoading: false,
      show: false,
      fullPage: true,
      form: {
        provider_id: "",
        from: "",
        to: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    //
  },
  methods: {
    getComments() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/comments`, {
          params: {
            paginate_value: 30,
            agency_id: 95930,
            provider_id: this.form.provider_id,
            from: this.form.from,
            to: this.form.to,
          },
        })
        .then((response) => {
          this.comments = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getRequest(trf) {
      this.isLoading = true;

      this.single_request = trf;

      this.isLoading = false;
    },

    getProviders() {
      this.axios
        .get(`/api/v1/auth/providerAgency/95930`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    IncreamentPage() {
      this.pageNum = this.pageNum + 1;
      this.getComments();
    },
    DecreamentPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
        this.getComments();
      }
    },
  },
  created() {
    this.getComments();
    this.getProviders();
  },
};
</script>
  
  <style scoped>
.pagination__CTAs {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.currentPage {
  margin: 0 2rem;
  font-weight: 600;
}

.dropdown-menu {
  padding: 1rem;
}
.spacer-side {
  margin-left: 3px;
  margin-right: 3px;
}
</style>
  